// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToEndOfChain } from "@insite/client-framework/HandlerCreator";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Pages/RequestRma/Handlers/SendRmaRequest";
import { OrderLineModel } from "@insite/client-framework/Types/ApiModels";
import { xGoogleAnalyticsState } from "@stoneage/App/Store/Reducers";
import { getBillToCustomerNumber, getDataLayer, trackAsImpersonation } from "@stoneage/App/Utilities/DataLayer";
import { xOrderLines } from "@stoneage/App/Utilities/XOrderLines";

export const TrackGaReturnRequestEvent: typeof PopulateApiParameter = props => {
    const state = props.getState() as xGoogleAnalyticsState;

    if (state.xGoogleAnalytics.returnRequestEvent) {
        const dataLayer = getDataLayer();
        if (!dataLayer) {
            return;
        }

        const customerNumber = getBillToCustomerNumber(state);
        const orderLines = xOrderLines(state.pages.requestRma.orderLines).orderlinesList as OrderLineModel[];

        if (orderLines?.length) {
            const googleAnalyticsData = {
                event: "return_request",
                affiliation: customerNumber || "",
                items: orderLines
                    .filter(x => x.rmaQtyRequested > 0)
                    .map(line => ({
                        erpNumber: line.productErpNumber,
                        value: line.extendedUnitNetPriceDisplay,
                        quantity: line.rmaQtyRequested,
                        reason: line.rmaQtyRequested,
                    })),
                impersonation: trackAsImpersonation(state),
            };

            dataLayer.push(googleAnalyticsData);
        }
    }
};

addToEndOfChain(chain, TrackGaReturnRequestEvent);
